// TODO: namespace module

import Vue from 'vue'
import _ from 'lodash'
import {Raven} from 'vue-raven'
import {getRandomId} from '@/utils'
import {getDirectPathModel} from '@/models/workflow/path/path'
import {
    ACTION_FOR_EACH_BREAK,
    ACTION_START,
    APP_BLOCK_CONNECTION,
    APP_BLOCK_MODULE,
    MODEL_ENTITY_ACTION,
    MODEL_ENTITY_APP,
    MODEL_ENTITY_RULE,
    WORKFLOW_OBJ_TYPE_GLOBAL_PROPERTIES,
    WORKFLOW_OBJ_TYPE_LOOP_ITEM,
    WORKFLOW_OBJ_TYPE_MODULE_ERROR_INTERFACE,
    WORKFLOW_OBJ_TYPE_MODULE_INTERFACE,
    WORKFLOW_PATH_EMPTY,
    WORKFLOW_PATH_ERROR,
    WORKFLOW_PATH_FALSE,
    WORKFLOW_PATH_GROUP_ENTRY,
    WORKFLOW_PATH_GROUP_EXIT,
    WORKFLOW_PATH_SUCCESS
} from '@/models/workflow'
import {workflowRules} from '@/models/workflow/rules'
import {workflowActions} from '@/models/workflow/actions'
import {getBlockModel} from '@/models/workflow/block/block'
import {getBlockShapeModel} from '@/models/workflow/block/shape'
import {getBlockIconModel} from '@/models/workflow/block/icon'
import {getWorkflowNoteBlock} from '@/models/workflow/notes'
import {getPathConnectorModelForBlock} from '@/views/workflow/path-connector/path-connector'
import {RED, WHITE_MUTED} from '@/models/workflow/colors'
import {
    BU_SHAPE_HEIGHT,
    BU_SHAPE_MX,
    BU_SHAPE_MY,
    BU_SHAPE_PX,
    BU_SHAPE_PY,
    BU_SHAPE_WIDTH
} from '@/models/workflow/block/block-units'
import axios from 'axios'

import {getPathFromEvaluationExpression} from '@/utils/workflow'
import {AUTOMATION_APPS_FETCH, AUTOMATION_APPS_SET} from '../../mutations'
import {workflowPlotGrids} from '@/types/workflow/plot'
import {WorkflowGlobalPropertySource} from '@/types/workflow/object'
import {WORKFLOW_TOOL_APP, WORKFLOW_ZUDELLO_APP, WORKFLOW_ZUDELLO_LOG_ERROR_MODULE} from '@/types/workflow/block'
import {zParameterTypes} from '@/types/z/parameters'
import {workflowApi} from '@/api/workflow'
import {APP_MODULE_TYPE_TRIGGER} from '@/models/apps/modules/module-types'

export const WORKFLOW_MODAL_EDITOR_BLOCK = 'WORKFLOW_MODAL_EDITOR_BLOCK'
export const WORKFLOW_MODAL_EDITOR_MAPPING = 'WORKFLOW_MODAL_EDITOR_MAPPING'
export const WORKFLOW_MODAL_EDITOR_EXPRESSION = 'WORKFLOW_MODAL_EDITOR_EXPRESSION'
export const WORKFLOW_MODAL_EDITOR_MESSAGE = 'WORKFLOW_MODAL_EDITOR_MESSAGE'

// Action/mutation types
export const WORKFLOW_MODAL_STACK_PUSH = 'WORKFLOW_MODAL_STACK_PUSH'
export const WORKFLOW_MODAL_STACK_POP = 'WORKFLOW_MODAL_STACK_POP'

export const WORKFLOW_UPDATE = 'WORKFLOW_UPDATE'
export const WORKFLOW_CLEAR_MODEL = 'WORKFLOW_CLEAR_MODEL'
export const WORKFLOW_SET_BLOCKS = 'WORKFLOW_SET_BLOCKS'
export const WORKFLOW_SET_BLOCK_GROUPS = 'WORKFLOW_SET_BLOCK_GROUPS'
export const WORKFLOW_SET_PATHS = 'WORKFLOW_SET_PATHS'
export const WORKFLOW_SET_OBJECTS = 'WORKFLOW_SET_OBJECTS'
export const WORKFLOW_SET_STATUS = 'WORKFLOW_SET_STATUS'
export const WORKFLOW_SET_SELECTED = 'WORKFLOW_SET_SELECTED' // selected

export const WORKFLOW_NOTE_ADD = 'WORKFLOW_NOTE_ADD'
export const WORKFLOW_NOTE_UPDATE = 'WORKFLOW_NOTE_UPDATE'
export const WORKFLOW_NOTE_REMOVE = 'WORKFLOW_NOTE_REMOVE'
export const WORKFLOW_SET_NOTES = 'WORKFLOW_SET_NOTES'

export const WORKFLOW_BLOCK_ADD = 'WORKFLOW_BLOCK_ADD'
export const WORKFLOW_BLOCK_DUPLICATE = 'WORKFLOW_BLOCK_DUPLICATE'
export const WORKFLOW_BLOCK_ADD_APP_BLOCK = 'WORKFLOW_BLOCK_ADD_APP_BLOCK'
export const WORKFLOW_BLOCK_REMOVE = 'WORKFLOW_BLOCK_REMOVE'
export const WORKFLOW_BLOCK_UPDATE = 'WORKFLOW_BLOCK_UPDATE'
export const WORKFLOW_BLOCK_REPLACE = 'WORKFLOW_BLOCK_REPLACE'

export const WORKFLOW_BLOCK_GROUP_ADD = 'WORKFLOW_BLOCK_GROUP_ADD'
export const WORKFLOW_BLOCK_GROUP_REMOVE = 'WORKFLOW_BLOCK_GROUP_REMOVE'
export const WORKFLOW_BLOCK_GROUP_UPDATE = 'WORKFLOW_BLOCK_GROUP_UPDATE'

export const WORKFLOW_PATH_ADD = 'WORKFLOW_PATH_ADD'
export const WORKFLOW_PATH_REMOVE = 'WORKFLOW_PATH_REMOVE'
export const WORKFLOW_PATH_UPDATE = 'WORKFLOW_PATH_UPDATE'

export const WORKFLOW_OBJECT_ADD = 'WORKFLOW_OBJECT_ADD'
export const WORKFLOW_OBJECT_REMOVE = 'WORKFLOW_OBJECT_REMOVE'
export const WORKFLOW_OBJECT_UPDATE = 'WORKFLOW_OBJECT_UPDATE'

export const WORKFLOW_SETTINGS_UPDATE = 'WORKFLOW_SETTINGS_UPDATE'
export const WORKFLOW_SETTINGS_RESET = 'WORKFLOW_SETTINGS_RESET'
export const WORKFLOW_SET_EDITABLE_STATUS = 'WORKFLOW_SET_EDITABLE_STATUS'
export const WORKFLOW_TOGGLE_DEBUG_MODE = 'WORKFLOW_TOGGLE_DEBUG_MODE'

export const WORKFLOW_SYNC_APP_PROPERTIES_BETWEEN_BLOCKS = 'WORKFLOW_SYNC_APP_PROPERTIES_BETWEEN_BLOCKS'
export const WORKFLOW_SYNC_GLOBAL_PROPERTIES_OBJECT = 'WORKFLOW_SYNC_GLOBAL_PROPERTIES_OBJECT'

const getDefaultWorkflowSettings = () => ({
    hasGrid: true,
    hasGridGravity: true,
    gridKey: 'small',
    showHiddenPaths: false
})

const state = {
    workflowModalStack: [],
    selectedWorkflow: null, // to update block/path/objects use normalized parts bellow

    isEnabled: false,
    blocks: [],
    blockGroups: [],
    paths: [],
    notes: [],
    workflowObjects: [],
    workflowSettings: getDefaultWorkflowSettings(),
    isEditable: false,
    debugMode: false,
    apps: []
}

/**
 * Returns all incoming objects (passed along paths) excluding global objects and inaccessible loop objects
 * */
const getBlockIncomingObjectIds = (id, getters) => {
    function getBlockAvailableObjectIds(blockId) { // all incoming
        let ids = []
        const checkedBlockIds = []

        function _recursiveSearch(blockId) { // workflow graph traverse
            checkedBlockIds.push(blockId)
            for (const parentBlockId of getters.getParentBlockIds(blockId)) {
                ids = ids.concat(getters.getBlockSourceObjectIds(parentBlockId))
                // We are searching in such a way to avoid stackoverflow on looped connections
                if (id !== parentBlockId && checkedBlockIds.indexOf(parentBlockId) === -1) { // not checked blocks
                    _recursiveSearch(parentBlockId)
                }
            }
        }

        _recursiveSearch(blockId)
        return _.uniq(ids)
    }

    function filterNotAvailableLoopObjects(objectIds) { // Interrupted by a loop exit block
        let availableBlockIds
        const loopObjectIds = getters.workflowObjects.filter(o => o.type === WORKFLOW_OBJ_TYPE_LOOP_ITEM).map(o => o.id)
        for (const loopObjectId of loopObjectIds) {
            if (objectIds.includes(loopObjectId)) {
                availableBlockIds = getters.getBlockIdsWhereLoopObjectIsAvailable(loopObjectId)
                if (!availableBlockIds.includes(id)) {
                    objectIds = objectIds.filter(id => id !== loopObjectId)
                }
            }
        }
        return objectIds
    }

    function filterNotAvailableErrorObjects(objectIds) { // Only block connected with error path should receive error object
        const errorObjects = getters.workflowObjects.filter(o => o.type === WORKFLOW_OBJ_TYPE_MODULE_ERROR_INTERFACE)
        for (const errorObject of errorObjects) {
            const errorObjectSourceBlock = getters.getBlockById(errorObject.sourceBlockId)
            if (errorObjectSourceBlock &&
                errorObjectSourceBlock.model &&
                errorObjectSourceBlock.model[WORKFLOW_PATH_ERROR] &&
                errorObjectSourceBlock.model[WORKFLOW_PATH_ERROR] === id) {
            } else {
                objectIds = objectIds.filter(id => id !== errorObject.id)
            }
        }
        return objectIds
    }

    return filterNotAvailableErrorObjects(filterNotAvailableLoopObjects(getBlockAvailableObjectIds(id)))
}

const getters = {
    workflowModalStack: state => state.workflowModalStack,
    workflowSettings: state => state.workflowSettings || {},
    workflowGridModel: state => workflowPlotGrids.find(g => g.key === state.workflowSettings.gridKey) || workflowPlotGrids[0],
    selectedWorkflow: state => state.selectedWorkflow,
    isEnabledWorkflow: state => state.isEnabled,
    isEditableWorkflow: state => state.isEditable,

    blocks: state => state.blocks || [],
    paths: state => state.paths || [],
    notes: state => state.notes || [],

    blockGroups: state => state.blockGroups || [],

    visibleBlocks: state => state.blocks.filter(b => !b.isHidden),
    visiblePaths: (state, getters) => state.paths.filter(p => {
        const blockFrom = getters.getBlockById(p.from)
        const blockTo = getters.getBlockById(p.to)
        return ( // path visible
            (p.visible || !p.hasOwnProperty('visible')) || (getters.showHiddenPaths && !p.visible)
        ) && (
            ( // both blocks are visible
                !_.get(blockFrom, 'isHidden', false) &&
                !_.get(blockTo, 'isHidden', false)
            ) || ( // hidden block is placed in a group
                (
                    _.get(blockFrom, 'isHidden', false) &&
                    _.get(blockFrom, 'groupId') &&
                    !_.get(blockTo, 'isHidden', false)
                ) || (
                    _.get(blockTo, 'isHidden', false) &&
                    _.get(blockTo, 'groupId') &&
                    !_.get(blockFrom, 'isHidden', false)
                )
            ) || ( // both hidden but in the group
                _.get(blockFrom, 'isHidden', false) &&
                _.get(blockTo, 'isHidden', false) &&
                _.get(blockFrom, 'groupId') && _.get(blockTo, 'groupId') &&
                _.get(blockFrom, 'groupId') !== _.get(blockTo, 'groupId')
            )
        )
    }),

    workflowObjects: state => state.workflowObjects || [],
    getWorkflowObjectById: (state, getters) => id => getters.workflowObjects.find(o => o.id === id) || {},
    getWorkflowGlobalObjectIds: (state, getters) => getters.workflowObjects.filter(o => o.isGlobal).map(o => o.id) || [],
    getWorkflowObjectLabelWithBlockNamePrefix: (state, getters) => obj => {
        if (obj) {
            if ([
                WORKFLOW_OBJ_TYPE_MODULE_INTERFACE, // NOTE: interface object name equal to block name (so use label only)
                WORKFLOW_OBJ_TYPE_GLOBAL_PROPERTIES
            ].includes(obj.type)) {
                return obj.label
            }
            const block = getters.getBlockById(obj.sourceBlockId)
            if (block) {
                return `${block.name}: ${obj.label}`
            }
        }
        return ''
    },
    workflowGlobalPropertiesObject: (state, getters) => getters.workflowObjects.find(o => o.type === WORKFLOW_OBJ_TYPE_GLOBAL_PROPERTIES) || {},
    workflowGlobalPropertiesObjectData: (state, getters) => _.isArray(getters.workflowGlobalPropertiesObject.data) ? getters.workflowGlobalPropertiesObject.data : [],

    /**
     * @return WorkflowObjectField | WorkflowGlobalProperty | null
     */
    getWorkflowObjectFieldByEvaluationExpression: (state, getters) => expression => {
        const path = getPathFromEvaluationExpression(expression)
        if (path.length === 0) {
            return null
        }
        const objectId = path[0]
        const object = getters.getWorkflowObjectById(objectId)
        if (!object || !_.isArray(object.data)) {
            return null
        }
        // TODO: extend for deep nested fields inside 'spec' for zParameterTypes.COLLECTION or zParameterTypes.ARRAY
        // (now works only for root object fields)
        return object.data.find(prop => prop && prop.name === path[1])
    },

    getMapParamDefaultValueByEvaluationExpression: (state, getters) => expression => {
        const field = getters.getWorkflowObjectFieldByEvaluationExpression(expression)
        if (!field || !field.default || !field.default.value) {
            return null
        }
        return field.default.value
    },

    getParentBlockIds: (state, getters) => blockId => getters.paths.filter(p => p.to === blockId).map(p => p.from) || [],
    getChildBlockIds: (state, getters) => blockId => getters.paths.filter(p => p.from === blockId).map(p => p.to) || [],

    getNoteById: (state, getters) => id => getters.notes.find(n => n.id === id),
    getPathById: (state, getters) => id => getters.paths.find(p => p.id === id),
    getBlockById: (state, getters) => id => getters.blocks.find(b => b.id === id),
    getBlockGroupById: (state, getters) => id => getters.blockGroups.find(g => g.id === id),
    getGroupBlocks: (state, getters) => groupId => getters.blocks.filter(b => b.groupId === groupId),
    getGroupExitBlock: (state, getters) => groupId => {
        const group = getters.getBlockGroupById(groupId)
        if (group && group[WORKFLOW_PATH_GROUP_EXIT]) {
            return getters.getBlockById(group[WORKFLOW_PATH_GROUP_EXIT])
        }
    },
    getGroupEntryBlock: (state, getters) => groupId => {
        const group = getters.getBlockGroupById(groupId)
        if (group && group[WORKFLOW_PATH_GROUP_ENTRY]) {
            return getters.getBlockById(group[WORKFLOW_PATH_GROUP_ENTRY])
        }
    },

    getBlockSourceObjectIds: (state, getters) => id => getters.workflowObjects.filter(o => o.sourceBlockId === id).map(o => o.id),
    getBlockIncomingObjectIds: (state, getters) => id => {
        return _.uniq([
            ...getBlockIncomingObjectIds(id, getters),
            ...getters.getWorkflowGlobalObjectIds
        ])
    },
    getBlockIncomingObjects: (state, getters) => blockId => {
        return getters.getBlockIncomingObjectIds(blockId)
            .map(id => getters.getWorkflowObjectById(id)) || []
    },
    getBlockSourceObjects: (state, getters) => blockId => {
        return getters.workflowObjects.filter(obj => obj.sourceBlockId === blockId) || []
    },
    getBlocksWhereObjectIsUsed: (state, getters) => objectId => {
        return getters.blocks.filter(block => getBlockIncomingObjectIds(block.id, getters).includes(objectId))
    },
    // All blocks after exit loop block should't have access to loop object
    getBlockIdsWhereLoopObjectIsAvailable: (state, getters) => loopObjectId => {
        const loopObject = getters.getWorkflowObjectById(loopObjectId)
        if (!loopObject) {
            return []
        }
        const sourceBlock = getters.getBlockById(loopObject.sourceBlockId)
        if (!sourceBlock) {
            return []
        }

        function recursiveSearchBlockIds(blockId) {
            let blockIds = []
            let childBlock
            getters.getChildBlockIds(blockId).forEach(childBlockId => {
                childBlock = getters.getBlockById(childBlockId)
                if (childBlock && !blockIds.includes(childBlock)) {
                    if ((childBlock.model.key === ACTION_FOR_EACH_BREAK &&
                            childBlock.model.loopBlockId === blockId) ||
                        sourceBlock.model.end_path === childBlockId ||
                        sourceBlock.id === childBlockId) { // loops in workflow
                        // end of chain on loop exit
                    } else {
                        blockIds.push(childBlockId)
                        blockIds = blockIds.concat(recursiveSearchBlockIds(childBlock.id))
                    }
                }
            })

            return blockIds
        }

        return recursiveSearchBlockIds(loopObject.sourceBlockId)
    },
    /**
     * @return {null} | {String} connection uuid |
     * {Object} like {
     *     isMap: true,
     *     value: `{{ object_id.prop }}`
     * }
     * where the value is a workflow object property reference
     * (usually from global config object, see WORKFLOW_OBJ_TYPE_GLOBAL_PROPERTIES)
     * */
    getBlockAuthConnectionData: (state, getters) => blockId => {
        return _.get(
            getters.getBlockById(blockId),
            ['model', MODEL_ENTITY_APP, APP_BLOCK_CONNECTION, 'authConnectionUuid']
        )
    },
    getBlockAuthConnectionUuid: (state, getters) => blockId => {
        const connection = getters.getBlockAuthConnectionData(blockId)
        if (connection && connection.isMap) {
            return getters.getMapParamDefaultValueByEvaluationExpression(connection.value)
        } else {
            return connection
        }
    },
    getPathsFromBlock: (state, getters) => block => getters.paths.filter(p => p.from === block.id),
    getPathsToBlock: (state, getters) => block => getters.paths.filter(p => p.to === block.id),

    getDistanceBetweenBlocks: () => (blockFrom, blockTo) => {
        if (!blockFrom || !blockTo) {
            return Infinity
        }
        return Math.sqrt(Math.pow(blockFrom.attrs.x - blockTo.attrs.x, 2) + Math.pow(blockFrom.attrs.y - blockTo.attrs.y, 2))
    },

    getBlocksBoundingRect: () => blocks => {
        const rect = {x: 0, y: 0, width: 0, height: 0}
        if (!blocks || !_.isArray(blocks)) {
            return rect
        }
        let minX = Infinity
        let maxX = -Infinity
        let minY = Infinity
        let maxY = -Infinity
        for (const {attrs: {x, y}} of blocks) {
            if (x < minX) {
                minX = x
            }
            if (x > maxX) {
                maxX = x
            }
            if (y < minY) {
                minY = y
            }
            if (y > maxY) {
                maxY = y
            }
        }
        rect.x = minX + BU_SHAPE_MX - 2 * BU_SHAPE_PX
        rect.y = minY + BU_SHAPE_MY - 2 * BU_SHAPE_PY
        rect.width = maxX - minX + BU_SHAPE_WIDTH + 4 * BU_SHAPE_PX
        rect.height = maxY - minY + BU_SHAPE_HEIGHT + 4 * BU_SHAPE_PY
        return rect
    },

    checkIsConnectedBlocks: (state, getters) => (blockFrom, blockTo) => {
        if (!blockFrom || !blockTo) {
            return false
        }
        return getters.paths.some(p =>
            (p.to === blockTo.id && p.from === blockFrom.id) ||
            (p.from === blockTo.id && p.to === blockFrom.id))
    },

    checkIsAllowedConnectionBetweenBlocks: (state, getters) => (blockFrom, blockTo) => {
        return !getters.checkIsConnectedBlocks(blockFrom, blockTo) &&
            getters.checkIsAllowedConnectionFromBlock(blockFrom) &&
            getters.checkIsAllowedConnectionToBlock(blockTo)
    },

    checkIsAllowedConnectionFromBlock: (state, getters) => block => {
        const allowed = !!(
            block && block.validations && block.validations.paths && block.validations.paths.from &&
            (getters.getPathsFromBlock(block).length < block.validations.paths.from.max ||
                block.validations.paths.from.max === -1))

        if (allowed && block && block.groupId && block.isHidden) {
            const exitBlock = getters.getGroupExitBlock(block.groupId)
            return !!exitBlock && exitBlock.id === block.id
        }
        return allowed
    },

    checkIsAllowedConnectionToBlock: (state, getters) => block => {
        const allowed = !!(
            block && block.validations && block.validations.paths && block.validations.paths.to &&
            (getters.getPathsToBlock(block).length < block.validations.paths.to.max ||
                block.validations.paths.to.max === -1))

        if (allowed && block && block.groupId && block.isHidden) {
            const entryBlock = getters.getGroupEntryBlock(block.groupId)
            return !!entryBlock && entryBlock.id === block.id
        }
        return allowed
    },
    showHiddenPaths: state => state.workflowSettings.showHiddenPaths,
    getWorkflowOwner: (state, getters, rootState, rootGetters) => {
        if (getters.selectedWorkflow) {
            return getters.selectedWorkflow.owner_uuid
                ? rootGetters.getMemberByUuid(getters.selectedWorkflow.owner_uuid)
                : null
        }
        return null
    },
    isEnabledWorkflowDebugMode: state => state.debugMode,

    apps: state => state.apps || [],
    zudelloApp: (state, getters) => getters.apps.find(app => app.name === WORKFLOW_ZUDELLO_APP),
    toolApp: (state, getters) => getters.apps.find(app => app.name === WORKFLOW_TOOL_APP),
    checkIsZudelloErrorBlock: (state, getters) => blockId => {
        return String(_.get(getters.getBlockById(blockId), 'model.name')).includes(WORKFLOW_ZUDELLO_LOG_ERROR_MODULE)
    },
    // NOTE: these blocks are created using the custom path connector (see pathConnectorCustomOptions)
    checkIsZudelloHiddenErrorBlock: (state, getters) => blockId => {
        const block = getters.getBlockById(blockId)
        return block && block.isHidden && getters.checkIsZudelloErrorBlock(blockId)
    }
}

const mutations = {
    [WORKFLOW_SET_SELECTED]: (state, data) => {
        state.selectedWorkflow = data
        if (data && data.settings) {
            state.workflowSettings = _.cloneDeep(data.settings)
        }
    },
    [WORKFLOW_UPDATE]: (state, data) => {
        state.selectedWorkflow = _.merge(state.selectedWorkflow, data)
        if (data && data.settings) {
            state.workflowSettings = _.cloneDeep(data.settings)
        }
    },
    [WORKFLOW_MODAL_STACK_PUSH]: (state, modalKey) => {
        state.workflowModalStack = state.workflowModalStack.concat(modalKey)
    },
    [WORKFLOW_MODAL_STACK_POP]: (state) => {
        state.workflowModalStack.splice(state.workflowModalStack.length - 1, 1)
    },
    [WORKFLOW_CLEAR_MODEL]: (state) => {
        state.isEnabled = false
        state.selectedWorkflow = null
        state.blocks = []
        state.paths = []
        state.notes = []
        state.blockGroups = []
        state.workflowModalStack = []
        state.workflowObjects = []
    },
    [WORKFLOW_SET_STATUS]: (state, data) => {
        state.isEnabled = !!data
    },

    // BLOCK
    [WORKFLOW_SET_BLOCKS]: (state, data) => {
        state.blocks = data || []
    },
    [WORKFLOW_BLOCK_ADD]: (state, block) => {
        state.blocks = state.blocks.concat([block])
    },
    [WORKFLOW_BLOCK_UPDATE]: (state, {id, path, data}) => {
        const idx = state.blocks.findIndex(b => b && b.id === id)
        if (idx !== -1) {
            const newBlock = _.cloneDeep(state.blocks[idx])
            _.set(newBlock, path, data)
            Vue.set(state.blocks, idx, newBlock)
        }
    },
    [WORKFLOW_BLOCK_REPLACE]: (state, {id, block}) => {
        const idx = state.blocks.findIndex(b => b && b.id === id)
        if (idx !== -1) {
            state.blocks.splice(idx, 1, block)
        }
    },
    [WORKFLOW_BLOCK_REMOVE]: (state, {id}) => {
        const idx = state.blocks.findIndex(b => b.id === id)
        if (idx !== -1) {
            state.blocks.splice(idx, 1)
        }
    },

    // block group
    [WORKFLOW_SET_BLOCK_GROUPS]: (state, data) => {
        state.blockGroups = data || []
    },
    [WORKFLOW_BLOCK_GROUP_ADD]: (state, group) => {
        state.blockGroups = state.blockGroups.concat([group])
    },
    [WORKFLOW_BLOCK_GROUP_UPDATE]: (state, {id, path, data}) => {
        const idx = state.blockGroups.findIndex(b => b && b.id === id)
        if (idx !== -1) {
            const newGroup = _.cloneDeep(state.blockGroups[idx])
            _.set(newGroup, path, data)
            Vue.set(state.blockGroups, idx, newGroup)
        }
    },
    [WORKFLOW_BLOCK_GROUP_REMOVE]: (state, {id}) => {
        const idx = state.blockGroups.findIndex(b => b.id === id)
        if (idx !== -1) {
            state.blockGroups.splice(idx, 1)
        }
    },

    // PATH
    [WORKFLOW_SET_PATHS]: (state, data) => {
        state.paths = data || []
    },
    [WORKFLOW_PATH_ADD]: (state, path) => {
        state.paths = state.paths.concat([path])
    },
    [WORKFLOW_PATH_UPDATE]: (state, {id, path, data}) => {
        const idx = state.paths.findIndex(p => p.id === id)
        if (idx !== -1) {
            const newPath = _.cloneDeep(state.paths[idx])
            _.set(newPath, path, data)
            state.paths.splice(idx, 1, newPath)
        }
    },
    [WORKFLOW_PATH_REMOVE]: (state, {id}) => {
        const idx = state.paths.findIndex(p => p.id === id)
        if (idx !== -1) {
            state.paths.splice(idx, 1)
        }
    },

    // NOTES
    [WORKFLOW_SET_NOTES]: (state, data) => {
        state.notes = data || []
    },
    [WORKFLOW_NOTE_ADD]: (state, note) => {
        state.notes = state.notes.concat([note])
    },
    [WORKFLOW_NOTE_UPDATE]: (state, {id, path, data}) => {
        const idx = state.notes.findIndex(n => n && n.id === id)
        if (idx !== -1) {
            state.notes.splice(idx, 1, _.set(state.notes[idx], path, data))
        }
    },
    [WORKFLOW_NOTE_REMOVE]: (state, {idx}) => {
        state.notes.splice(idx, 1)
    },

    // OBJECT
    [WORKFLOW_SET_OBJECTS]: (state, data) => {
        state.workflowObjects = data || []
    },
    [WORKFLOW_OBJECT_ADD]: (state, obj) => {
        state.workflowObjects = state.workflowObjects.concat([obj])
    },
    [WORKFLOW_OBJECT_UPDATE]: (state, {id, path, data}) => {
        const idx = state.workflowObjects.findIndex(obj => obj.id === id)
        if (idx !== -1) {
            state.workflowObjects.splice(idx, 1, _.set(state.workflowObjects[idx], path, data))
        }
    },
    [WORKFLOW_OBJECT_REMOVE]: (state, {id}) => {
        const idx = state.workflowObjects.findIndex(obj => obj.id === id)
        if (idx !== -1) {
            state.workflowObjects.splice(idx, 1)
        }
    },

    // Settings
    [WORKFLOW_SETTINGS_UPDATE]: (state, {path, data}) => {
        const newSettings = _.cloneDeep(state.workflowSettings)
        _.set(newSettings, path, data)
        state.workflowSettings = newSettings
    },
    [WORKFLOW_SETTINGS_RESET]: (state) => {
        state.workflowSettings = getDefaultWorkflowSettings()
    },
    [WORKFLOW_SET_EDITABLE_STATUS]: (state, status) => {
        state.isEditable = !!status
    },
    [WORKFLOW_TOGGLE_DEBUG_MODE]: state => {
        state.debugMode = !state.debugMode
    },
    [AUTOMATION_APPS_SET]: (state, data) => {
        state.apps = data
    }
}

const actions = {
    [WORKFLOW_BLOCK_ADD]: ({commit, getters}, {entity, entityKey, x = 0, y = 0}) => {
        let block = null
        if (entity === MODEL_ENTITY_RULE) {
            block = _.cloneDeep(workflowRules[entityKey])
        } else if (entity === MODEL_ENTITY_ACTION) {
            block = _.cloneDeep(workflowActions[entityKey])
        } else {
            Raven.captureException('Unknown workflow block entity type')
            return
        }
        if (block.id === false) { // multiple blocks allowed
            block.id = getRandomId('block')
        } else if (getters.blocks.some(b => b.id === block.id)) {
            return Vue.prototype.$snackbar.show({
                type: 'INFO',
                text: 'Block already added',
                caption: 'Only one block with this type is allowed'
            })
        }

        if (!block.attrs.x) {
            block.attrs.x = x || _.random(-40, 40) // NOTE: randomize the initialization position around [0, 0] if x-y not specified
        }
        if (!block.attrs.y) {
            block.attrs.y = y || _.random(-40, 40)
        }
        block.metadata.isNewBlock = true
        commit(WORKFLOW_BLOCK_ADD, block)
        return block
    },

    [WORKFLOW_BLOCK_DUPLICATE]: async({commit, getters, dispatch}, originalBlock) => {
        const block = _.cloneDeep(originalBlock)
        const originalBlockId = block.id
        const newBlockId = getRandomId('block')
        block.id = newBlockId
        block.attrs.y += 100
        block.metadata.isNewBlock = true

        if (block.entity === MODEL_ENTITY_APP) {
            block.model[WORKFLOW_PATH_SUCCESS] = null
            block.model[WORKFLOW_PATH_ERROR] = null
            block.model[WORKFLOW_PATH_EMPTY] = null
        }
        const isTriggerBlock = _.get(block, ['model', MODEL_ENTITY_APP, APP_BLOCK_MODULE, 'type']) === APP_MODULE_TYPE_TRIGGER
        if (isTriggerBlock) {
            _.set(block, ['model', MODEL_ENTITY_APP, APP_BLOCK_MODULE, 'state'], null)
        }

        commit(WORKFLOW_BLOCK_ADD, block)
        let objects = _.cloneDeep(getters.getBlockSourceObjects(originalBlockId))
        objects.forEach(o => {
            o.id = getRandomId('data')
            o.sourceBlockId = newBlockId
            commit(WORKFLOW_OBJECT_ADD, o)
        })
        return block
    },

    [WORKFLOW_BLOCK_ADD_APP_BLOCK]: async({commit, getters, dispatch}, {
        app,
        appModule,
        x = 0,
        y = 0,
        isHidden = false
    }) => {
        let block = getBlockModel(false, appModule.name, [
            getBlockShapeModel(),
            getBlockIconModel('plug') // app.icon used instead
        ], {
            entity: MODEL_ENTITY_APP,
            name: appModule.name,
            description: appModule.description,

            [WORKFLOW_PATH_SUCCESS]: null, // block "To" id
            [WORKFLOW_PATH_ERROR]: null, // block "To" id
            [WORKFLOW_PATH_EMPTY]: null, // block "To" id

            [MODEL_ENTITY_APP]: {
                name: app.name,
                uuid: app.uuid,
                [APP_BLOCK_MODULE]: {
                    uuid: appModule.uuid,
                    name: appModule.name,
                    type: appModule.type,
                    state: null // token (presented only for APP_MODULE_TYPE_TRIGGER)
                },
                [APP_BLOCK_CONNECTION]: { // added later
                    uuid: null,
                    name: null
                }
            }
        }, {
            paths: {
                from: {min: 0, max: 3},
                to: {min: 1, max: -1}
            }
        }, {
            isChanged: false,
            isEditableModel: true
        }, x, y, isHidden)
        block.id = getRandomId('block')
        block.metadata.isNewBlock = true

        await dispatch(WORKFLOW_OBJECT_ADD, {
            sourceBlockId: block.id,
            type: WORKFLOW_OBJ_TYPE_MODULE_INTERFACE,
            label: block.name,
            data: appModule.interface || [], // TODO: (!) re-fetch interface data and update on each load == sync with staff portal data
            appUuid: app.uuid,
            appModuleUuid: appModule.uuid,
            appModuleType: appModule.type
        })

        await dispatch(WORKFLOW_OBJECT_ADD, {
            sourceBlockId: block.id,
            type: WORKFLOW_OBJ_TYPE_MODULE_ERROR_INTERFACE,
            label: 'Error',
            data: [{
                type: zParameterTypes.NUMBER,
                name: 'code',
                label: 'Code'
            }, {
                type: zParameterTypes.TEXT,
                name: 'type',
                label: 'Type'
            }, {
                type: zParameterTypes.TEXT,
                name: 'message',
                label: 'Message'
            }],
            appUuid: app.uuid,
            appModuleUuid: appModule.uuid,
            appModuleType: appModule.type
        })

        commit(WORKFLOW_BLOCK_ADD, block)

        return block
    },

    [WORKFLOW_BLOCK_REMOVE]: async({commit, getters, dispatch}, {id}) => {
        const block = getters.getBlockById(id)
        if (!block) {
            return
        }

        if (!block.isHidden) { // condition to prevent cyclic deletion for zudello hidden error blocks
            const connectedHiddenZudelloErrorBlocks = getters.blocks.filter(b => {
                return getters.checkIsZudelloHiddenErrorBlock(b.id) &&
                    getters.checkIsConnectedBlocks(block, b)
            })
            for (const {id: errorBlockId} of connectedHiddenZudelloErrorBlocks) {
                await dispatch(WORKFLOW_BLOCK_REMOVE, {id: errorBlockId})
            }
        }

        const paths = getters.paths.filter(p => p.from === block.id || p.to === block.id)
        for (const path of paths) {
            await dispatch(WORKFLOW_PATH_REMOVE, {id: path.id})
        }
        for (const objId of getters.getBlockSourceObjectIds(block.id)) {
            commit(WORKFLOW_OBJECT_REMOVE, {id: objId})
        }
        commit(WORKFLOW_BLOCK_REMOVE, {id})

        // (!) after removing specified block above to avoid maximum call stack exceed
        if (block.groupId) {
            const groupBlocks = getters.getGroupBlocks(block.groupId)
            if (groupBlocks.length === 0) {
                commit(WORKFLOW_BLOCK_GROUP_REMOVE, {id: block.groupId})
            }
            // with remove one group block removes all in the group:
            // for (const groupBlock of getters.blocks.filter(b => b.groupId === block.groupId)) {
            //     await dispatch(WORKFLOW_BLOCK_REMOVE, {id: groupBlock.id})
            // }
        }
    },

    // PATH
    [WORKFLOW_PATH_ADD]: ({getters, commit}, {
        from,
        to,
        text = '',
        stroke = WHITE_MUTED,
        lineType = undefined,
        visible = true
    }) => {
        if (from === to) {
            Vue.prototype.$snackbar.show({
                type: 'INFO',
                text: 'Change destination',
                caption: `Path "from" and "to" should be different`
            })
            return
        }
        for (const path of getters.paths) {
            if (path.from === from && path.to === to) {
                Vue.prototype.$snackbar.show({
                    type: 'INFO',
                    text: 'Path already exists'
                })
                return
            }
        }

        const a = getters.blocks.find(b => b.id === from)
        const b = getters.blocks.find(b => b.id === to)
        if (!a || !b || !a.id || !b.id) {
            return
        }

        let label = text
        if (a.model) {
            // Run block specific auto-connector
            for (const m of getPathConnectorModelForBlock(a)) {
                if (a.model[m.key] || getters.checkIsZudelloHiddenErrorBlock(b.id)) {
                    continue
                }
                if ([WORKFLOW_PATH_FALSE, WORKFLOW_PATH_ERROR].includes(m.key)) {
                    stroke = RED
                }
                if (!label) {
                    label = m.caption
                }
                commit(WORKFLOW_BLOCK_UPDATE, {id: a.id, path: ['model', m.key], data: b.id})
                break
            }
        }
        const path = getDirectPathModel(from, to, label, stroke, lineType, visible)
        path.id = getRandomId('path')
        commit(WORKFLOW_PATH_ADD, path)
        return path
    },

    [WORKFLOW_PATH_REMOVE]: ({getters, commit}, {id}) => {
        const path = getters.paths.find(p => p.id === id)
        if (!path || !path.from || !path.to) {
            return
        }
        const blockFrom = getters.getBlockById(path.from)
        if (blockFrom) {
            getPathConnectorModelForBlock(blockFrom).forEach(m => {
                if (path.to === blockFrom.model[m.key]) {
                    commit(WORKFLOW_BLOCK_UPDATE, {id: blockFrom.id, path: ['model', m.key], data: null})
                }
            })
        }
        commit(WORKFLOW_PATH_REMOVE, {id})
    },

    [WORKFLOW_NOTE_ADD]: ({getters, commit}, {text, x, y}) => {
        const note = getWorkflowNoteBlock(text, x, y)
        note.id = getRandomId('note')
        commit(WORKFLOW_NOTE_ADD, note)
        return note
    },

    /**
     * @see WorkflowObject
     */
    [WORKFLOW_OBJECT_ADD]: ({commit, getters}, {
        sourceBlockId,
        type = '',
        label = '',
        data = [],
        isGlobal = false,

        appUuid,
        appModuleUuid,
        appModuleType,
        documentTypeUuid
    }) => {
        if (!sourceBlockId) {
            Vue.prototype.$snackbar.show({
                type: 'INFO',
                text: 'Specify source block id'
            })
            return
        }

        const obj = {
            id: getRandomId('data'),
            sourceBlockId,
            isGlobal,
            label,
            data,
            type
        }

        if (appUuid) {
            obj.appUuid = appUuid
        }
        if (appModuleUuid) {
            obj.appModuleUuid = appModuleUuid
        }
        if (appModuleType) {
            obj.appModuleType = appModuleType
        }
        if (documentTypeUuid) {
            obj.documentTypeUuid = documentTypeUuid
        }
        commit(WORKFLOW_OBJECT_ADD, obj)
        return obj
    },

    [AUTOMATION_APPS_FETCH]({commit}) {
        return axios.get(`automation/workflows/apps`)
            .then(res => {
                commit(AUTOMATION_APPS_SET, res.data.data || [])
            })
    },

    [WORKFLOW_BLOCK_REPLACE]: async({dispatch, getters, commit}, {
        sourceBlockId,
        targetBlockId
    }) => {
        await dispatch(WORKFLOW_SYNC_APP_PROPERTIES_BETWEEN_BLOCKS, {sourceBlockId, targetBlockId})
        const paths = getters.paths.filter(p => [p.from, p.to].includes(sourceBlockId))
        await dispatch(WORKFLOW_BLOCK_REMOVE, {id: sourceBlockId})
        // replace paths
        for (const {attrs, from, to} of paths) {
            const fromBlock = getters.getBlockById(from === sourceBlockId ? targetBlockId : from)
            const toBlock = getters.getBlockById(to === sourceBlockId ? targetBlockId : to)
            if (getters.checkIsAllowedConnectionBetweenBlocks(fromBlock, toBlock)) {
                const newPath = await dispatch(WORKFLOW_PATH_ADD, {from: fromBlock.id, to: toBlock.id})
                commit(WORKFLOW_PATH_UPDATE, {id: newPath.id, path: 'attrs', data: attrs})
            }
        }
    },

    [WORKFLOW_SYNC_APP_PROPERTIES_BETWEEN_BLOCKS]: async({dispatch, getters, commit}, {
        sourceBlockId,
        targetBlockId
    }) => {
        try {
            const sourceBlock = _.cloneDeep(getters.getBlockById(sourceBlockId))
            const targetBlock = _.cloneDeep(getters.getBlockById(targetBlockId))
            if (!_.get(sourceBlock, ['model', MODEL_ENTITY_APP, 'uuid']) ||
                !_.get(targetBlock, ['model', MODEL_ENTITY_APP, 'uuid'])) {
                return
            }

            // 1. copy connection
            if (sourceBlock.model[MODEL_ENTITY_APP].hasOwnProperty(APP_BLOCK_CONNECTION)) {
                commit(WORKFLOW_BLOCK_UPDATE, {
                    id: targetBlock.id,
                    path: ['model', MODEL_ENTITY_APP, APP_BLOCK_CONNECTION],
                    data: sourceBlock.model[MODEL_ENTITY_APP][APP_BLOCK_CONNECTION]
                })
            }

            // 2. copy mappable params
            const sourceBlockModule = sourceBlock.model[MODEL_ENTITY_APP][APP_BLOCK_MODULE]
            const targetBlockModule = targetBlock.model[MODEL_ENTITY_APP][APP_BLOCK_MODULE]
            if (!_.isPlainObject(_.get(sourceBlockModule, 'mappableParameters'))) {
                return
            }
            const targetBlockModuleUuid = _.get(targetBlock, ['model', MODEL_ENTITY_APP, APP_BLOCK_MODULE, 'uuid'])
            if (!targetBlockModuleUuid) {
                return
            }
            // load target module interface since empty mappable params not written in block model data
            const targetBlockAppUuid = _.get(targetBlock, ['model', MODEL_ENTITY_APP, 'uuid'])
            const {data, error} = await workflowApi.fetchAppModules(targetBlockAppUuid)
            if (error) {
                return
            }
            const targetBlockModuleInterface = data.find(module => module.uuid === targetBlockModuleUuid)
            if (!_.isArray(_.get(targetBlockModuleInterface, 'mappableParameters'))) {
                return
            }
            const mappableParams = {}
            targetBlockModuleInterface.mappableParameters.forEach(({name}) => {
                if (_.get(targetBlockModule, ['mappableParameters', name])) {
                    mappableParams[name] = _.cloneDeep(targetBlockModule.mappableParameters[name])
                } else if (_.get(sourceBlockModule, ['mappableParameters', name])) {
                    mappableParams[name] = _.cloneDeep(sourceBlockModule.mappableParameters[name])
                }
            })
            if (!_.isEmpty(mappableParams)) {
                commit(WORKFLOW_BLOCK_UPDATE, {
                    id: targetBlock.id,
                    path: ['model', MODEL_ENTITY_APP, APP_BLOCK_MODULE, 'mappableParameters'],
                    data: mappableParams
                })
            }
        } catch (e) {
        }
    },

    /**
     * Create global config object if not exists
     * and mix in data from external properties.
     * (properties with the same name created in the current workflow have a higher priority)
     * */
    [WORKFLOW_SYNC_GLOBAL_PROPERTIES_OBJECT]: async({getters, commit, dispatch, rootGetters}) => {
        let obj = getters.workflowGlobalPropertiesObject
        if (!obj || !obj.id) {
            obj = await dispatch(WORKFLOW_OBJECT_ADD, {
                sourceBlockId: ACTION_START,
                type: WORKFLOW_OBJ_TYPE_GLOBAL_PROPERTIES,
                label: 'Workflow properties',
                isGlobal: true,
                data: []
            })
        }
        // rebuild data every time from scratch
        const workflowProperties = obj.data
            .filter(p => p.meta && p.meta.source !== WorkflowGlobalPropertySource.EXTERNAL)
            .map(p => ({...p, meta: {...p.meta, source: WorkflowGlobalPropertySource.WORKFLOW}}))

        const externalProperties = rootGetters['workflow_global_properties/globalPropertiesData']
            .map(p => ({...p, meta: {...p.meta, source: WorkflowGlobalPropertySource.EXTERNAL}}))

        const data = workflowProperties.concat(
            externalProperties
                .filter(p1 => !workflowProperties.some(p2 => p2.name === p1.name))
        )

        commit(WORKFLOW_OBJECT_UPDATE, {
            id: obj.id,
            path: ['data'],
            data
        })
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
